import { Button } from "../../Button/Button"

export const SeniorenplatformAccountPopup = ({ dictionary, loginUrl, registerUrl, closePopup, ...props }) => {

    const containerClicked = (e) => {
        if (e.target.className == "c-senioren__account__popup__container") {
            closePopup();
        }
    }

    return <div className="c-senioren__account__popup__container" onClick={(evt) =>containerClicked(evt)}>
        <div className="c-senioren__account__popup">
            <div className="c-senioren__account__popup__content">
                <div className="c-senioren__account__popup__content__header">
                    <h5 className="c-senioren__account__popup__content__header__title">
                        {dictionary.onlySupervisors}
                    </h5>
                    <i class="fa-solid fa-x" onClick={() => closePopup()}></i>
                </div>
                <div className="c-senioren__account__popup__content__body">
                    {/* BOTTOM */}
                    <SeniorenPlatformAccountMessage dark={false} loginUrl={loginUrl} registerUrl={registerUrl} dictionary={dictionary} />
                </div>
            </div>
        </div>
    </div>
}


export const SeniorenPlatformAccountMessage = ({ dictionary, loginUrl, registerUrl, dark, ...props }) => {

    return <div id={props.id} className={`c-senioren__account__loginmessage ${dark ? "dark" : ""} ${props.className ? props.className : ""}`}>
        <h4>
            {dictionary.loginMessage}
        </h4>
        <ul>
            <li>
                <i class="fa-solid fa-check"></i> {dictionary.loginMessagePunt1}
            </li>
            <li>
                <i class="fa-solid fa-check"></i> {dictionary.loginMessagePunt2}
            </li>
            <li>
                <i class="fa-solid fa-check"></i> {dictionary.loginMessagePunt3}
            </li>
        </ul>
        <div className='c-senioren__account__loginmessage__footer'>
            <div className="c-senioren__account__loginmessage__footer__right">
                <span className='c-senioren__account__loginmessage__footer__accountlabel'>
                    {dictionary.alreadyHaveAnAccount}
                </span>
                <Button label={dictionary.login} buttonType={"secondary"} className="c-senioren__account__loginmessage__footer__login" onClick={() => window.location.href = `${loginUrl}?targetlogin=${window.location.pathname}`} />
            </div>
        </div>
    </div>
}